import React from "react";
import { useTranslation } from "react-i18next";
import "~/css/ReceptionCommunicatingIndicator.css";

/**
 * 受付フローのAPI通信中に表示するオーバーレイインジケーター。
 */
const ReceptionCommunicatingIndicator: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="reception-communicating-indicator-overlay"
      aria-busy="true"
      aria-live="polite"
      data-testid="reception-communicating-indicator"
    >
      <div className="reception-communicating-indicator">
        <div className="reception-communicating-spinner" />
        <span className="reception-communicating-indicator-text">
          {t("receptionStandby.communicating")}
        </span>
      </div>
    </div>
  );
};

export default ReceptionCommunicatingIndicator;
